export const TO_STAGE_CONSTANTS = {
  development: 'DEV',
  production: 'PROD',
};
